function numberValue(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

export function tetrisTargetStorageKey(unionId, seasonNo, phaseNo) {
  return `dororaid:tetris-targets:${String(unionId || 'union')}:${Number(seasonNo || 0)}:phase-${Number(phaseNo || 1)}`;
}

export function liveTetrisTargetMap(bosses = []) {
  return Object.fromEntries((Array.isArray(bosses) ? bosses : []).map((boss) => [
    Number(boss.bossNo),
    Math.max(0, numberValue(boss.remainingHpEok)),
  ]));
}

export function reconcileTetrisTargetValues({ storedValues = {}, bosses = [], isInfinityStage = false } = {}) {
  const liveTargets = liveTetrisTargetMap(bosses);
  return Object.fromEntries(Object.entries(liveTargets).map(([bossNo, liveTarget]) => {
    const storedTarget = numberValue(storedValues?.[bossNo], liveTarget);
    if (isInfinityStage) return [bossNo, Math.max(0, storedTarget)];
    return [bossNo, Math.min(Math.max(0, storedTarget), liveTarget)];
  }));
}

export function syncTetrisTargetStorage({ storage, unionId, season } = {}) {
  if (!storage || !season) return null;
  const key = tetrisTargetStorageKey(unionId, season.seasonNo, season.globalPhase);
  let storedValues = {};
  try {
    storedValues = JSON.parse(storage.getItem(key) || '{}');
  } catch {
    storedValues = {};
  }

  const next = reconcileTetrisTargetValues({
    storedValues,
    bosses: season.bosses,
    isInfinityStage: numberValue(season.globalPhase, 1) >= 4,
  });

  try {
    if (JSON.stringify(storedValues) !== JSON.stringify(next)) storage.setItem(key, JSON.stringify(next));
  } catch { /* storage unavailable */ }
  return next;
}
